import { ResponsiveModal } from "@/components/responsive-modal";
import { Button, Flex, Text } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

interface CancelSubscriptionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const CancelSubscriptionDialog = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}: CancelSubscriptionDialogProps) => {
  const { t } = useTranslation();

  return (
    <ResponsiveModal
      isOpen={isOpen}
      onClose={onClose}
      title={t("billing.cancel_dialog.title")}
      height="auto"
    >
      <Flex direction="column" gap="4">
        <Flex align="center" gap="3" className="text-amber-600">
          <Text size="3" weight="medium">
            {t("billing.cancel_dialog.description")}
          </Text>
        </Flex>

        <Flex
          direction="column"
          gap="3"
          className="bg-slate-50 dark:bg-slate-800 p-4 rounded-lg"
        >
          <Flex align="start" gap="3">
            <div className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0" />
            <Text size="2">{t("billing.cancel_dialog.point_1")}</Text>
          </Flex>

          <Flex align="start" gap="3">
            <div className="w-2 h-2 bg-yellow-500 rounded-full mt-2 flex-shrink-0" />
            <Text size="2">{t("billing.cancel_dialog.point_2")}</Text>
          </Flex>

          <Flex align="start" gap="3">
            <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0" />
            <Text size="2">{t("billing.cancel_dialog.point_3")}</Text>
          </Flex>
        </Flex>

        <Flex gap="3" justify="end" className="mt-4">
          <Button
            variant="soft"
            color="gray"
            onClick={onClose}
            disabled={isLoading}
          >
            {t("billing.cancel_dialog.cancel")}
          </Button>
          <Button
            variant="solid"
            color="red"
            onClick={onConfirm}
            disabled={isLoading}
            loading={isLoading}
          >
            {isLoading
              ? t("billing.cancel_dialog.cancelling")
              : t("billing.cancel_dialog.confirm")}
          </Button>
        </Flex>
      </Flex>
    </ResponsiveModal>
  );
};
